<template>
  <div class="gas-kinetic-theory-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>P = (2/3) n (1/2 mv²)$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 混合渲染：分子碰撞模拟 -->
      <div class="canvas-item simulation">
         <svg width="100%" height="240" viewBox="0 0 400 240">
            <!-- 容器边界 -->
            <rect x="50" y="40" width="300" height="160" fill="none" stroke="#555" stroke-width="2" rx="4" />
            
            <!-- 分子 -->
            <circle v-for="p in particles" :key="p.id" :cx="p.x" :cy="p.y" r="3" :fill="getParticleColor(p.v)" />

            <!-- 压力计 (侧壁压力感应) -->
            <rect x="350" y="40" width="10" height="160" :fill="`rgba(255, 71, 87, ${pressureIntensity})`" />
         </svg>

         <div class="hud-top">
            <div class="stat">
               <label>微观动能 Ek</label>
               <span :style="{ color: getParticleColor(temperature) }">{{ (temperature * 10).toFixed(0) }} K</span>
            </div>
            <div class="stat">
               <label>宏观压强 P</label>
               <span>{{ (pressureIntensity * 100).toFixed(1) }} kPa</span>
            </div>
         </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row">
               <div class="col">
                  <label>加热温度</label>
                  <el-slider v-model="temperature" :min="10" :max="100" size="mini"></el-slider>
               </div>
               <div class="col">
                  <label>分子数量 (n)</label>
                  <el-slider v-model="particleCount" :min="10" :max="50" size="mini"></el-slider>
               </div>
            </div>
         </div>

         <div class="discovery-note" v-latex>
            <p><strong>微观解释：</strong>气体压强是大量分子频繁撞击器壁产生的平均压力。温度升高，分子平均速率增大，碰撞更剧烈，压强随之增大。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GasKineticTheoryViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      temperature: 30,
      particleCount: 25,
      particles: [],
      pressureIntensity: 0.1,
      running: true
    }
  },
  watch: {
    particleCount(val) {
      this.syncParticles(val);
    }
  },
  mounted() {
    this.syncParticles(this.particleCount);
    this.animate();
  },
  beforeDestroy() { this.running = false; },
  methods: {
    syncParticles(count) {
       while(this.particles.length < count) {
          this.particles.push({ 
             id: Date.now() + Math.random(),
             x: 60 + Math.random()*280, 
             y: 50 + Math.random()*140, 
             vx: (Math.random()-0.5)*2,
             v: 1
          });
       }
       if(this.particles.length > count) this.particles.splice(count);
    },
    getParticleColor(v) {
       const hue = 200 - v * 20;
       return `hsl(${Math.max(0, hue)}, 80%, 60%)`;
    },
    animate() {
       if (!this.running) return;
       const speedScale = this.temperature / 10;
       let collisions = 0;

       this.particles.forEach(p => {
          p.x += p.vx * speedScale;
          p.y += (Math.random()-0.5) * speedScale;
          p.v = speedScale; // Simplification

          // Boundary bounce
          if (p.x < 55 || p.x > 345) {
             p.vx *= -1;
             collisions++;
          }
          if (p.y < 45 || p.y > 195) {
             // simplified vertical
          }
       });

       this.pressureIntensity = this.pressureIntensity * 0.9 + (collisions * 0.05) * 0.1;
       requestAnimationFrame(this.animate);
    }
  }
}
</script>

<style scoped lang="scss">
.gas-kinetic-theory-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #ffab00; background: rgba(255,171,0,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-item { 
   background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
   .hud-top { position: absolute; top: 15px; left: 15px; display: flex; gap: 20px;
      .stat { background: rgba(0,0,0,0.5); padding: 5px 12px; border-radius: 6px; border-left: 3px solid #ff4757; label { display: block; font-size: 0.55rem; color: #888; } span { font-size: 0.9rem; color: #fff; font-family: monospace; } }
   }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; .row { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } } }
.discovery-note { background: rgba(255, 171, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
